import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { HubSectionType } from '@alucio/aws-beacon-amplify/src/models';
import {
  WidgetContentCardProps,
  WidgetCardHeader,
  WidgetCardBody,
  WidgetContextMenu,
} from 'src/screens/Hubs/EditHub/Widgets/WidgetContentCard';
import InputComponent from 'src/components/Publishers/InputComponent';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
import { useHubsState } from 'src/state/context/Hubs/HubsStateProvider.proxy';
import { HubType } from '@alucio/aws-beacon-amplify/lib/models';
import { DNAText } from '@alucio/lux-ui';
import { getWidgetFormName } from 'src/screens/Hubs/EditHub/useHubForm';

const Textarea: React.FC<WidgetContentCardProps> = ({ widget, rhForm }) => {
  const [content, setContent] = useState<string | undefined>(widget.textarea?.content)
  const { hubORM } = useHubsState()  
  const widgetFormName = getWidgetFormName(widget.id)
  useEffect(() => {
    rhForm.setValue(widgetFormName,
      widget,
      { shouldDirty: true })
  }, [])

  const updateContent = useCallback((text: string) => {
    setContent(text)
    const textareaFormValue = rhForm.getValues(widgetFormName)
    
    if (textareaFormValue) {
      const newValue = {
        ...textareaFormValue,
        textarea: { content: text },
        updatedAt: new Date().toISOString()
      }
      rhForm.setValue(widgetFormName, newValue, { shouldDirty: true })
    }
  }, [rhForm])

  const rightElement = useMemo(() => (
    <Iffy is={hubORM?.model.hubType !== HubType.TEMPLATE_INSTANCE}>
      <WidgetContextMenu widgetType={HubSectionType.TEXTAREA} id={widget.id} />
    </Iffy>
  ), [widget.locked])

  if (widget.type !== HubSectionType.TEXTAREA) return null
  if (widget.type === HubSectionType.TEXTAREA && widget.locked && hubORM?.model.hubType === HubType.TEMPLATE_INSTANCE) {
    return (
      <>
      <WidgetCardHeader
        widget={widget}
        rightElement={rightElement}
      />
      <WidgetCardBody>
        <DNAText>
          {content}
        </DNAText>
      </WidgetCardBody>
    </>
    )
  }
  return (
    <>
      <WidgetCardHeader
        widget={widget}
        rightElement={rightElement}
      />
      <WidgetCardBody>
        <InputComponent
          testID='hub-text-box-input'
          onChangeText={updateContent}
          value={content}
          removeMarginPadding
          multiline
          showCharacterCounter={false}
          required={false}
          numOfLines={7}
          disabled={hubORM?.model.hubType === HubType.TEMPLATE_INSTANCE && widget.locked}
        />
      </WidgetCardBody>
    </>
  )
}

export default Textarea
